
import querystring from 'vux/src/tools/querystring/index.js'

import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Search from 'vux/src/components/search/index.vue'

export default {
components: {
Datetime,
PopupPicker,
Group,
Cell,
XButton,
XInput,
Box,
Search
},
data() {
return {
ENGINE_NO: '',
THCK: [],
CAR_GP: [],
DTR_TH: '',
DTR_OVER: '',
th_ware_list: [],
sh_ware_list: []
}
},
computed: {
search() {
return this.$store.state.search
}
},
created() {
this.getWareData()
},
activated() {
let store_keywords = this.search.keywords;
if (!store_keywords.ENGINE_NO) this.ENGINE_NO = ''
if (!store_keywords.THCK) this.THCK = []
if (!store_keywords.CAR_GP) this.CAR_GP = []
if (!store_keywords.DTR_TH) this.DTR_TH = ''
if (!store_keywords.DTR_OVER) this.DTR_OVER = ''
},
methods: {
getWareData() {
let _this = this;
this.$combo('TH_WARE', function(res) {
_this.th_ware_list = res;
})
this.$combo('SH_WARE', function(res) {
_this.sh_ware_list = res;
})
},
onClear() {
this.ENGINE_NO = ''
},
toSearch() {
let keywords = {};
if (this.ENGINE_NO) {
keywords.ENGINE_NO = this.ENGINE_NO
} else {
keywords.ENGINE_NO = '';
keywords.THCK = this.THCK.length > 0 ? this.THCK[0] : '';
keywords.CAR_GP = this.CAR_GP.length > 0 ? this.CAR_GP[0] : '';
keywords.DTR_TH = this.DTR_TH;
keywords.DTR_TH_F = keywords.DTR_TH_T = this.DTR_TH;
keywords.DTR_OVER = this.DTR_OVER;
keywords.DTR_OVER_F = keywords.DTR_OEVR_T = this.DTR_OVER;
keywords.TH_WARE = this.$refs.pickerTh.getNameValues()
keywords.SH_WARE = this.$refs.pickerSh.getNameValues()
}
this.$store.commit('setKeywords', keywords)
this.$router.go(-1)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/Asus/Search.vue